"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormularioSectionTitle = void 0;
var estiloFormularioSectionTitle = require('./FormularioSectionTitle.module.scss');
var react_1 = __importDefault(require("react"));
var FormularioSectionTitle = function (_a) {
    var children = _a.children, style = _a.style;
    return (react_1.default.createElement("div", { className: estiloFormularioSectionTitle.formularioTitleSecao, style: style },
        react_1.default.createElement("div", { className: estiloFormularioSectionTitle.campoTituloSecaoContainerLabel }, children)));
};
exports.FormularioSectionTitle = FormularioSectionTitle;
